<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half is-full-mobile">
        <window title="Basic">
          <div id="hot-preview">
            <HotTable :root="root" :settings="hotSettings"></HotTable>
          </div>
        </window>
      </div>
      <div class="column is-half is-full-mobile">
        <window title="Fixed columns and rows">
          <div id="hot-preview">
            <HotTable :root="root" :settings="hotSettings2"></HotTable>
          </div>
        </window>
      </div>
      <div class="column is-half is-full-mobile">
        <window title="Moving">
          <div id="hot-preview">
            <HotTable :root="root" :settings="hotSettings3"></HotTable>
          </div>
        </window>
      </div>
      <div class="column is-half is-full-mobile">
        <window title="Resize">
          <div id="hot-preview">
            <HotTable :root="root" :settings="hotSettings4"></HotTable>
          </div>
        </window>
      </div>
      <div class="column is-half is-full-mobile">
        <window title="Sorting">
          <div id="hot-preview">
            <HotTable :root="root" :settings="hotSettings5"></HotTable>
          </div>
        </window>
      </div>
    </div>
  </div>
</template>

<script>
import HotTable from '@handsontable/vue';
import Handsontable from 'handsontable';

export default {
  data() {
    const dataTable = Handsontable.helper.createSpreadsheetData(15, 15);
    return {
      root: 'test-hot',
      searchField: '',
      hotSettings: {
        data: dataTable,
        colHeaders: true,
        rowHeaders: true,
      },
      hotSettings2: {
        data: dataTable,
        colHeaders: true,
        rowHeaders: true,
        fixedRowsTop: 2,
        fixedColumnsLeft: 2,
      },
      hotSettings3: {
        data: dataTable,
        colHeaders: true,
        rowHeaders: true,
        manualColumnMove: true,
        manualRowMove: true,
      },
      hotSettings4: {
        data: dataTable,
        colHeaders: true,
        rowHeaders: true,
        manualColumnResize: true,
        manualRowResize: true,
      },
      hotSettings5: {
        data: dataTable,
        colHeaders: true,
        rowHeaders: true,
        columnSorting: true,
        sortIndicator: true,
      },
    };
  },
  components: {
    HotTable,
  },
};
</script>

<style src="handsontable/dist/handsontable.full.css"></style>

<style>
#test-hot {
  height: 300px;
  overflow: hidden;
}
</style>
